"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextLeftAlignedSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28,6H4A2,2,0,0,1,4,2H28a2,2,0,0,1,0,4Z"/><path d="M21,14H4a2,2,0,0,1,0-4H21a2,2,0,0,1,0,4Z"/><path d="M28,22H4a2,2,0,0,1,0-4H28a2,2,0,0,1,0,4Z"/><path d="M15,30H4a2,2,0,0,1,0-4H15a2,2,0,0,1,0,4Z"/>';
var TextLeftAlignedSVG = function TextLeftAlignedSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TextLeftAlignedSVG = TextLeftAlignedSVG;
TextLeftAlignedSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TextLeftAlignedSVG);
exports.default = _default;